import { useAppDispatch, useAppSelector } from "./reduxHooks";
import { BodySolicitudDemanda } from "interfaces/demandas/demandasInterface";
import {
  onSolicitudesPromociones,
  onSolicitudesPromocionesPenales,
  onSolicitudesPromocionesLaborales,
  onChangeTiposJuzgados,
  onAddMateriasOrdinarias,
  onAddInstanciasOrdinarias,
  onAddJuzgadosOrdinarias,
  onIsEnLinea,
  onIsTipoPenal,
  onAddTipoCarpetas,
  onShowModalNuevaPromocion,
  onAddIdMateria,
  onAllResetPromocionesState,
  onAddCarpetaJudicial,
  onAddFormBusquedaCarpetaJudicial,
  onChangeStepSolicitudPromocion,
  onAddCapturaPartesPromoventes,
  onAddNotasSintesisForm,
  onAddSecretoNotasForm,
  onAddResponseSolicitudPromocion,
  onAddListUploaddedFilesPromocion,
  onAddFileStep,
  onAddDocumentSelectedPromocion,
  onAddInitialCapturaPromovente,
  onResetStateStepOne,
  onAddSuccessRegisterPromocion,
  onAddSolicitudPromocionSelected,
  onAddSolicitudPromocionDocumentos,
  onUpdateListSolicitudesPromociones,
  onAddPromoventePortada,
  onAddPromocionSeleccionada,
  onAddJuzgadoSeleccionado,
  onAddSinzeFile,
} from "store/promociones/promocionesSlice";
import {
  deleteFileSolicitudPromocion,
  deleteSolcitudPromocion,
  getAcusePromocion,
  getFileSolicitudPromocion,
  getInstanciasOrdinariasEnLinea,
  getJuzgadosOrdinariasEnLinea,
  getMateriasOridinariasEnLinea,
  getSolicitudesPromocion,
  getSolicitudesPromocionLaboral,
  getSolicitudesPromocionPenal,
  getSolicitudPromocionById,
  getSolicitudPromocionLaboral,
  postRegistrarPromocion,
  postSaveSolicitudPromocion,
  postUploadFilePromocion,
  putUpdateSolicitudPromocion,
} from "services/promociones/promocionesService";
import { useUiStore } from "./useUiStore";
import {
  BodySolicitudPromocion,
  BodySolicitudPromocionLaboral,
  DataSolicitudPromocion,
  FormBusquedaCarpetaJudicial,
  Instancia,
  Juzgado,
  JuzgadosOrdinariosResponse,
  Materia,
  ParamsPromociones,
} from "interfaces/promociones/promocionesInterface";
import {
  getCarpetaJudicial,
  getJuzgadosExpediente,
  getTiposNumeros,
} from "services/serviciosGenerales/serviciosGenerales";
import {
  BodyTipoCarpetasPenales,
  DataJuzgadosEelectronico,
  DataTiposCarpetas,
  FileArgs,
  FileBase64,
  ResponseJuzgadosElectronico,
  SolicitudCarpetaJudicial,
} from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import {
  setIsLoading,
  setIsLoadingPromocionesPenal,
  setMessageLoading,
  setOpenSnackBar,
} from "store";
import { CapturaPartesInterface } from "interfaces/capturaPartes/capturaPartesInterface";
import { useAuthStore } from "./useAuthStore";
import { useVisorDocumentosStore } from "./useVisorDocumentosStore";
import { listaErroresFirma } from "utils/_generals";
import Swal from "sweetalert2";
import { createIframe } from "utils/_createIframeBlobUrl";
import { obtenerTipoCarpetasPenales } from "services/expedientesAutorizados/expedientesAutorizadosServices";
import { ValidateStatus } from "components/componentesGenerales/firmaElectronica/interfaces/firmaInterfaces";
import { scrollToTop } from "utils/_scrollTop";
import localforage from "localforage";

export const usePromocionStore = () => {
  const dispatch = useAppDispatch();
  const {
    successRegisterPromocion,
    tiposJuzgados,
    solicitudPromocion,
    solicitudPromocionLaborales,
    solicitudPromocionPenales,
    promocionSelected,
    enLinea,
    tipoPenal,
    lstMaterias,
    lstJuzgados,
    lstInstancias,
    lstTipoCarpetas,
    selectJuzgado,
    showModalNuevaPromocion,
    materiaId,
    carpetaJudicial,
    formBusquedaCarpetaJudicial,
    stepPromocion,
    capturaPartesPromoventes,
    secretoFojasForm,
    notasSintesisForm,
    file,
    responseSolicitudPromocion,
    listUploaddedFiles,
    documentSelectedPromocion,
    initialCapturaPromoventes,
    solicitudPromocionSelected,
    solicitudPromocionDocumentos,
    promovente,
    totalSizeFile,
  } = useAppSelector((state) => state.promocion);
  const { user } = useAuthStore();
  const { openVisorDocumentos, addDocumentPDF, addDocumentoSeleccionado, addDocumentos, addPosicion } =
    useVisorDocumentosStore();
  const { optionsSnackBar, changeTotalPage } = useUiStore();

  const startGetSolicitudPromocionById = (id: number) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Buscando solicitud promoción"));
    getSolicitudPromocionById(id)
      .then(({ data }) => {
        dispatch(onAddSolicitudPromocionSelected(data.data));
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startGetSolicitudesPromociones = (body: BodySolicitudDemanda) => {
    dispatch(setIsLoading(true));
    getSolicitudesPromocion({ ...body })
      .then(({ data }) => {
        addSolicitudesPromociones(data.data.data);
        changeTotalPage(data.data.total);
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
      });
  };

  const startGetSolicitudesPromocionesPenal = (body: BodySolicitudDemanda) => {
    dispatch(setIsLoading(true));
    dispatch(setIsLoadingPromocionesPenal(true));
    getSolicitudesPromocionPenal({ ...body })
      .then(({ data }) => {
        changeTotalPage(data.data.totalCount);
        dispatch(onSolicitudesPromocionesPenales(data.data.data));
        dispatch(setIsLoadingPromocionesPenal(false));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
        dispatch(setIsLoadingPromocionesPenal(false));

      });
  };

  const startGetSolicitudesPromocionesLaboral = (
    body: BodySolicitudDemanda
  ) => {
    dispatch(setIsLoading(true));
    getSolicitudesPromocionLaboral({ ...body })
      .then(({ data }) => {
        changeTotalPage(data.data.totalCount);
        dispatch(onSolicitudesPromocionesLaborales(data.data.data));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
      });
  };

  const setTiposjuzgados = () => {
    dispatch(onChangeTiposJuzgados());
  };

  /*** nueva promocion - contestacion de la demanda */
  const startGetMateriasOrdinarias = (params: ParamsPromociones) => {
    dispatch(onAddMateriasOrdinarias([]));
    getMateriasOridinariasEnLinea(params)
      .then(({ data }) => {
        const dataListMaterias = data.data.map((materia: Materia) => {
          let body = {
            label: materia.descMateria,
            value: materia.cveMateria,
            ...materia,
          };
          return body;
        });
        dispatch(onAddMateriasOrdinarias(dataListMaterias));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetJuiciosOrdinariasEnLinea = (params: ParamsPromociones) => {
    dispatch(onAddJuzgadosOrdinarias([]));
    const arrayMaterias = [1, 2, 4, 6];
    const isTipoPenalN = params?.tipoPenal === "N";
    const isEnLineaN = params?.enLinea === "N";
    const isInArrayMaterias = arrayMaterias?.includes(
      Number(params?.cveMateria)
    );
    const handleJuzgados = (
      data: JuzgadosOrdinariosResponse | ResponseJuzgadosElectronico
    ) => {
      const dataListJuzgados = data.data.map(
        (juzgado: Juzgado | DataJuzgadosEelectronico) => ({
          label: juzgado.DesJuz,
          value: juzgado.IdJuzgado,
          ...juzgado,
        })
      );
      dispatch(onAddJuzgadosOrdinarias(dataListJuzgados));
    };
    if (isTipoPenalN && isEnLineaN && isInArrayMaterias) {
      getJuzgadosExpediente()
        .then(({ data }) => handleJuzgados(data))
        .catch((err) => console.error(err));
    } else {
      getJuzgadosOrdinariasEnLinea(params)
        .then(({ data }) => handleJuzgados(data))
        .catch((err) => {
          console.error(err);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error al obtener el listado de juzgados",
            icon: "warning",
          });
        });
    }
  };

  const startGetInstanciasOrdinariasEnLinea = (params: ParamsPromociones) => {
    dispatch(onAddInstanciasOrdinarias([]));
    getInstanciasOrdinariasEnLinea(params)
      .then(({ data }) => {
        const dataListInstancia = data.data.map((instancia: Instancia) => {
          let body = {
            label: instancia.descInstancia,
            value: instancia.cveInstancia,
            ...instancia,
          };
          return body;
        });
        dispatch(onAddInstanciasOrdinarias(dataListInstancia));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetTipoNumeros = (cveMateria: number) => {
    dispatch(onAddTipoCarpetas([]));
    getTiposNumeros(cveMateria)
      .then(({ data }) => {
        const dataListTipoCarpetas = data.data.map(
          (tipoCarpeta: DataTiposCarpetas) => {
            let body = {
              label: tipoCarpeta.descTipoNumero,
              value: tipoCarpeta.cveTipoNumero,
              ...tipoCarpeta,
            };
            return body;
          }
        );
        console.log(data);
        dispatch(onAddTipoCarpetas(dataListTipoCarpetas));
      })
      .catch((err) => {
        if (err.response.status === 404) {
          let body = {
            label: err.response.data.data,
            value: 0,
          };
          dispatch(onAddTipoCarpetas([body]));
        }
      });
  };

  const startGetTipoNumerosPenales = (params: BodyTipoCarpetasPenales) => {
    dispatch(onAddTipoCarpetas([]));
    obtenerTipoCarpetasPenales(params).then(({ data }) => {
      const dataListTipoCarpetas = data.data.map(
        (tipoCarpeta: DataTiposCarpetas) => {
          let body = {
            label: tipoCarpeta.descTipoNumero,
            value: tipoCarpeta.cveTipoNumero,
            ...tipoCarpeta,
          };
          return body;
        }
      );
      dispatch(onAddTipoCarpetas(dataListTipoCarpetas));
    });
  };

  const startGetCarpetaJudicial = (body: SolicitudCarpetaJudicial | any) => {
    dispatch(setIsLoading(true));
    /*   if (
      dataPeriodosInactividad?.descInactividad &&
      (( formBusquedaCarpetaJudicial?.cveadscripcion?.IdJuzgado !== null && formBusquedaCarpetaJudicial?.cveadscripcion?.IdJuzgado !== 11584) 
      || (carpetaJudicial?.length > 0 && carpetaJudicial?.[0]?.cveAdscripcion !== 11584))
    ) {
      Swal.fire({
        title: "No es posible continuar",
        html: `
          <style>
            .swal2-container {
              z-index: 99999
            }
          </style>
          <p>${dataPeriodosInactividad?.descInactividad}</p>`,
        icon: "info",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#801313",
      });
      dispatch(setIsLoading(false));
      return;
    } */
    getCarpetaJudicial(body)
      .then((res) => {
        console.log(res);
        handleShowModalNuevaPromocion(true);
        dispatch(onAddCarpetaJudicial(res?.data?.data));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log("err", err);
        Swal.fire({
          title: "Advertencia",
          text: err.response?.data?.data,
          icon: "warning",
        });
        dispatch(setIsLoading(false));
      });
  };

  const allresetPromocionesState = () => dispatch(onAllResetPromocionesState());

  const handleChangeEnLinea = (status: boolean) =>
    dispatch(onIsEnLinea(status));
  const handleChangeTipoPenal = (status: boolean) =>
    dispatch(onIsTipoPenal(status));
  const handleShowModalNuevaPromocion = (status: boolean) =>
    dispatch(onShowModalNuevaPromocion(status));
  const addIdMateria = (idMateria: number) =>
    dispatch(onAddIdMateria(idMateria));
  const addFormBusquedaCarpetaJudicial = (data: FormBusquedaCarpetaJudicial) =>
    dispatch(onAddFormBusquedaCarpetaJudicial(data));
  const setPromoventePortada = (data: any) =>
    dispatch(onAddPromoventePortada(data));

  /* steps solicitud promocion */

  const startSaveSolicitudPromocion = (body: BodySolicitudPromocion) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Guardando solicitud promoción"));
    if (!body?.noFojas) {
      Swal.fire({
        title: "Advertencia",
        text: "Fojas debe ser un número entero",
        icon: "warning",
        didClose: () => {
          scrollToTop();
        },
      });
      return;
    }
    /* if (
      dataPeriodosInactividad?.descInactividad &&
      (( formBusquedaCarpetaJudicial?.cveadscripcion?.IdJuzgado !== null && formBusquedaCarpetaJudicial?.cveadscripcion?.IdJuzgado !== 11584) 
      || (carpetaJudicial?.length > 0 && carpetaJudicial?.[0]?.cveAdscripcion !== 11584))
    ) {
      Swal.fire({
        title: "No es posible continuar",
        html: `
          <style>
            .swal2-container {
              z-index: 99999
            }
          </style>
          <p>${dataPeriodosInactividad?.descInactividad}</p>`,
        icon: "warning",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#801313",
      });
      dispatch(setIsLoading(false));
      dispatch(setMessageLoading(""));
      return;
    } */
    postSaveSolicitudPromocion(body)
      .then(({ data }) => {
        localforage.setItem("idSolicitudPromocion", JSON.stringify(data.data));
        localforage.setItem(
          "currentStepPromocion",
          JSON.stringify(stepPromocion + 1)
        );
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "Solicitud promoción registrada correctamente",
          })
        );
        addResponseSolicitudPromocion(data.data);
        changeStepSolicitudPromocion(stepPromocion + 1);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "Advertencia",
          text: "Ocurrio un problema al registrar la promoción",
          icon: "warning",
        });
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      });
  };

  const startUploadFilePromocion = () => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Subiendo Archivo"));

    let totalSize = listUploaddedFiles.reduce(
      (acumulador: number, actual: FileArgs) =>
        Number(acumulador) + Number(actual.size),
      0
    ); /* @ts-ignore */
    let totalSizePayload = file.reduce(
      (acumulador: number, actual: FileArgs) =>
        Number(acumulador) + Number(actual.size),
      0
    );

    /* @ts-ignore */
    const totalWithNewFile = Number(totalSizePayload) + totalSize;
    const totalTamañoDisponible = (totalWithNewFile / 30) * 100;

    if (totalTamañoDisponible > 100) {
      dispatch(
        setOpenSnackBar({
          status: true,
          message: "Los archivos superan los 30MB permitidos",
        })
      );
      dispatch(setIsLoading(false));
      setTimeout(() => {
        dispatch(setMessageLoading(""));
      }, 500);
      return;
    }

    let body = {
      idSolicitudActuacion:
        responseSolicitudPromocion?.resultados.idSolicitudActuacion,
      desDocumento: "SOLICITUD",
      cveUsuario: user.session?.cveUsuario,
      documents: file,
    };
    postUploadFilePromocion(body)
      .then(({ data }) => {
        /* @ts-ignore */
        //const listFilesMerge = mergeArrays(data.data, file);
        const listFilesMerge = data.data;
        const listFiles = [...listUploaddedFiles, ...listFilesMerge];
        const list = listFiles.map(({ ...args }) => {
          return args;
        });
        localforage.setItem("listFilesPromocion", JSON.stringify(list));
        addListFiles(listFiles);
        dispatch(setIsLoading(false));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "Se subio el archivo correctamente",
          })
        );
        setTimeout(() => {
          dispatch(setMessageLoading(""));
        }, 500);


      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        Swal.fire({
          title: "Ocurrio un problema al subir el archivo",
          text: err.response.data.data,
          icon: "error",
        });
      });
  };

  const startGetFileSolicitudPromocion = (path: any) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Cargando Archivo"));
    getFileSolicitudPromocion(path)
      .then(({ data }) => {
        const fileUrl = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );
        addDocumentPDF([fileUrl]);
        addDocumentoSeleccionado(fileUrl);
        dispatch(setIsLoading(false));
        openVisorDocumentos(true);
        setTimeout(() => {
          dispatch(setMessageLoading(""));
        }, 500);


      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "Advertencia",
          text: "Ocurrio un problema al obtener el archivo",
          icon: "error",
        });
        dispatch(setIsLoading(false));
        openVisorDocumentos(false);
        dispatch(setMessageLoading(""));
      });
  };

  const startUpdateSolicitudPromocion = (
    body: BodySolicitudPromocion,
    step: number
  ) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Actualizando solicitud promoción"));
    putUpdateSolicitudPromocion(body)
      .then(({ data }) => {
        localforage.setItem(
          "idSolicitudPromocion",
          JSON.stringify({
            ...data.data,
            promoventes: data.data.promoventes.all,
          })
        );
        localforage.setItem(
          "currentStepPromocion",
          JSON.stringify(stepPromocion + 1)
        );
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "Solicitud Promoción actualizada correctamente",
          })
        );
        changeStepSolicitudPromocion(step);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "Advertencia",
          text: err.response.data.data,
          icon: "warning",
        });
        addNotasSintesisForm(null);
        addSecretoFojasForm(null);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      });
  };

  const startDeleteFile = (file: FileArgs) => {
    dispatch(setMessageLoading("Eliminando Archivo"));
    dispatch(setIsLoading(true));
    deleteFileSolicitudPromocion({ path: file.path })
      .then(({ data }) => {
        const updatedList = listUploaddedFiles.filter(
          (fileUploadded: FileArgs) =>
            fileUploadded.path !== file.path
        );
        localforage.setItem("listFilesPromocion", JSON.stringify(updatedList));
        addListFiles(updatedList);
        dispatch(setIsLoading(false));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: data.data.message,
          })
        );
        setTimeout(() => {
          dispatch(setMessageLoading(""));
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: err.response.data.data,
          })
        );
      });
  };

  const getStatusFirmaTerminada = (
    dataFirmaAnticipada: any,
    dataStatusFirma: ValidateStatus
  ) => {
    if (dataFirmaAnticipada.error.length) {
      allresetPromocionesState();
      Swal.fire({
        title: "Advertencia",
        icon: "warning",
        confirmButtonText: "Aceptar",
        html: `<h5>Hubo un problema al terminar la firma , es necesario que generes  nuevamente la solicitud de promoción</h5>
          <div id="lista-errores"></div>
     `,
      }).then((result) => {
        if (result.isConfirmed) {
          localforage.removeItem("idSolicitudPromocion");
          localforage.removeItem("listFilesPromocion");
          localforage.removeItem("currentStepPromocion");
          localforage.removeItem("certSelected");
          // allresetPromocionesState();
        }
      });
      listaErroresFirma(dataFirmaAnticipada.error);
    }

    if (
      dataFirmaAnticipada.completadas.length &&
      dataStatusFirma.signed.length &&
      dataStatusFirma.signed[0].data.length
    ) {
      startRegisterSolicitudPromocion();
    } else {
      Swal.fire({
        title: "Advertencia",
        icon: "warning",
        confirmButtonText: "Aceptar",
        html: `<h5>Los archivos no se han firmado correctamente, es necesario que generes  nuevamente la solicitud de promoción</h5>
          <div id="lista-errores"></div>
     `,
      }).then((result) => {
        if (result.isConfirmed) {
          localforage.removeItem("idSolicitudPromocion");
          localforage.removeItem("listFilesPromocion");
          localforage.removeItem("currentStepPromocion");
          localforage.removeItem("certSelected");
          allresetPromocionesState();
        }
      });
    }
  };

  const startRegisterSolicitudPromocion = () => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Moviendo solicitud a promoción"));

    let body = {
      idSolicitudActuacion:
        responseSolicitudPromocion?.resultados.idSolicitudActuacion!,
      actualizarDocumentosSolicitud: true,
      contestaPrev: 0,
      esMedidaProt: false,
    };
    postRegistrarPromocion(body)
      .then(({ data }) => {
        if (typeof data.data === "string") {
          Swal.fire({
            title: "Advertencia",
            text: data.data,
            icon: "warning",
          });
          dispatch(onAddSuccessRegisterPromocion(true));
          return;
        }
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        Swal.fire({
          title: "Correcto",
          text: `Se envió la promoción correctamente ${data.data.resultados.descJuzgado} con número ${data.data.resultados.numActuacion}/${data.data.resultados.aniActuacion}`,
          icon: "success",
          showCancelButton: true,
          cancelButtonText: "Descargar Acuse",
          cancelButtonColor: "#c62828 ",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(onAddSuccessRegisterPromocion(true));
          } else if (result.isDismissed) {
            startGetAcusePromocion(data.data.resultados.idActuacion);
          }
        });
      })
      .catch((err) => {
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        Swal.fire({
          title: "Advertencia",
          text:
            err.response.data.data ||
            "No se ha podido registrar la promoción de manera correcta",
          icon: "warning",
        });
      });
  };

  const startGetAcusePromocion = (
    idActuacion: number,
    esConsultaTabla = false
  ) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Descargando Acuse"));
    getAcusePromocion(idActuacion)
      .then(({ data }) => {
        const fileUrl = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );
        createIframe(fileUrl);
        if (!esConsultaTabla) {
          dispatch(onAddSuccessRegisterPromocion(true));
        }
        dispatch(
          setOpenSnackBar({
            status: false,
            message: "",
          })
        );
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      })
      .catch((err) => {
        Swal.fire({
          title: "Advertencia",
          text: "Ocurrio un problema al obtener el acuse",
          icon: "warning",
        });
        if (!esConsultaTabla) {
          dispatch(onAddSuccessRegisterPromocion(true));
        }
        dispatch(
          setOpenSnackBar({
            status: false,
            message: "",
          })
        );
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      });
  };

  const startGetSolicitudArchivosPromocion = (id: number) => {
    dispatch(onAddSolicitudPromocionDocumentos([]));
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Solicitando archivos"));
    getSolicitudPromocionById(id)
      .then(({ data }) => {
        const documentos = Object.values(data.data.archivos);
        // arreglo documentos sin la última posición que es el tamaño de los archivos
        const filteredList = documentos.slice(0, documentos.length - 1);
        addDocumentos(filteredList);
        addPosicion(0);

        startGetFileSolicitudPromocion({ path: data.data.archivos?.[0]?.path });
        openVisorDocumentos(true);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        dispatch(onAddSolicitudPromocionDocumentos([]));
      });
  };

  const startDeleteSolicitudPromocion = (idSolicitudPromocion: number) => {
    dispatch(setMessageLoading("Eliminando solicitud promoción"));
    dispatch(setIsLoading(true));
    deleteSolcitudPromocion(idSolicitudPromocion)
      .then(({ data }) => {
        dispatch(
          setOpenSnackBar({
            status: true,
            message: data.data.message,
          })
        );
        dispatch(onUpdateListSolicitudesPromociones(idSolicitudPromocion));
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setOpenSnackBar({
            status: true,
            message: err.response.data.data,
            optionsSnackBar: {
              ...optionsSnackBar,
              type: "error",
            },
          })
        );
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startGetSolicitudPromocionLaboralFile = (
    body: BodySolicitudPromocionLaboral
  ) => {
    dispatch(onAddSolicitudPromocionDocumentos([]));
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Solicitando archivos"));
    getSolicitudPromocionLaboral(body)
      .then(({ data }) => {
        const listFiles = data.data.data.map((file) => {
          return file.img;
        });
        addDocumentPDF(listFiles);
        addDocumentoSeleccionado(listFiles[0]);
        openVisorDocumentos(true);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        dispatch(onAddSolicitudPromocionDocumentos([]));
      });
  };

  const addCapturaPartesPromoventes = (data: CapturaPartesInterface[] | any) =>
    dispatch(onAddCapturaPartesPromoventes(data));
  const addInitialCapturaPromovente = (data: CapturaPartesInterface[]) =>
    dispatch(onAddInitialCapturaPromovente(data));
  const changeStepSolicitudPromocion = (step: number) =>
    dispatch(onChangeStepSolicitudPromocion(step));
  const addNotasSintesisForm = (data: any) =>
    dispatch(onAddNotasSintesisForm(data));
  const addSecretoFojasForm = (data: any) =>
    dispatch(onAddSecretoNotasForm(data));
  const addFile = (file: FileBase64 | FileBase64[]) =>
    dispatch(onAddFileStep(file));
  const addListFiles = <T>(listFiles: T) =>
    dispatch(onAddListUploaddedFilesPromocion(listFiles));

  const addFileSelectedPromocion = (fileUrl: string | null) =>
    dispatch(onAddDocumentSelectedPromocion(fileUrl));
  const addResponseSolicitudPromocion = (
    solicitud: DataSolicitudPromocion | null
  ) => dispatch(onAddResponseSolicitudPromocion(solicitud));
  const addSolicitudesPromociones = (solicitudPromocion: any) =>
    dispatch(onSolicitudesPromociones(solicitudPromocion));

  const addPromocionSeleccionada = (promocion: any) =>
    dispatch(onAddPromocionSeleccionada(promocion));
  const resetStateStepOne = () => dispatch(onResetStateStepOne());
  // const addSinzeFiles = (sinzeFiles: number) => dispatch(onAddSinzeFile(sinzeFiles))

  const addSinzeFiles = (sinzeFiles: number) => dispatch(onAddSinzeFile(sinzeFiles));

  const addJuzgadoSelect = (IdJuzgado: number) => dispatch(onAddJuzgadoSeleccionado(IdJuzgado));

  return {
    /**Propiedades **/
    promocionSelected,
    enLinea,
    tipoPenal,
    lstMaterias,
    lstJuzgados,
    materiaId,
    lstInstancias,
    lstTipoCarpetas,
    tiposJuzgados,
    solicitudPromocion,
    solicitudPromocionPenales,
    solicitudPromocionLaborales,
    showModalNuevaPromocion,
    carpetaJudicial,
    formBusquedaCarpetaJudicial,
    stepPromocion,
    capturaPartesPromoventes,
    secretoFojasForm,
    notasSintesisForm,
    file,
    listUploaddedFiles,
    documentSelectedPromocion,
    responseSolicitudPromocion,
    initialCapturaPromoventes,
    successRegisterPromocion,
    solicitudPromocionSelected,
    solicitudPromocionDocumentos,
    promovente,
    selectJuzgado,
    totalSizeFile,
    /** Métodos **/
    addPromocionSeleccionada,
    setTiposjuzgados,
    startGetMateriasOrdinarias,
    startGetTipoNumerosPenales,
    startGetSolicitudesPromociones,
    startGetSolicitudesPromocionesPenal,
    startGetSolicitudesPromocionesLaboral,
    startGetJuiciosOrdinariasEnLinea,
    startGetInstanciasOrdinariasEnLinea,
    handleChangeEnLinea,
    handleChangeTipoPenal,
    startGetTipoNumeros,
    startGetCarpetaJudicial,
    handleShowModalNuevaPromocion,
    addIdMateria,
    allresetPromocionesState,
    addFormBusquedaCarpetaJudicial,
    addCapturaPartesPromoventes,
    addNotasSintesisForm,
    addSecretoFojasForm,
    startSaveSolicitudPromocion,
    changeStepSolicitudPromocion,
    addFile,
    startUploadFilePromocion,
    addListFiles,
    addFileSelectedPromocion,
    startGetFileSolicitudPromocion,
    startDeleteFile,
    addResponseSolicitudPromocion,
    getStatusFirmaTerminada,
    startUpdateSolicitudPromocion,
    addInitialCapturaPromovente,
    resetStateStepOne,
    startGetSolicitudPromocionById,
    startRegisterSolicitudPromocion,
    startGetSolicitudArchivosPromocion,
    startDeleteSolicitudPromocion,
    startGetSolicitudPromocionLaboralFile,
    startGetAcusePromocion,
    addSolicitudesPromociones,
    setPromoventePortada,
    addJuzgadoSelect,
    addSinzeFiles,
  };
};
